import { render, staticRenderFns } from "./CategoryInfo.vue?vue&type=template&id=09c41950&scoped=true"
import script from "./CategoryInfo.vue?vue&type=script&lang=js"
export * from "./CategoryInfo.vue?vue&type=script&lang=js"
import style0 from "./CategoryInfo.vue?vue&type=style&index=0&id=09c41950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c41950",
  null
  
)

export default component.exports